import * as React from 'react';
import clsx from 'clsx';

interface SettingsHeaderProps {
  icon: string;
  title: string;
  description: React.ReactNode;
  isEditing?: boolean;
}

export const SettingsHeader: React.FC<SettingsHeaderProps> = ({
  icon,
  title,
  description,
  isEditing,
}) => (
  <div
    className={clsx(
      'flex w-full',
      // Mobile: Icon top, Text bottom (Column)
      'flex-col gap-3',
      // Desktop: Icon left, Text right (Row)
      'md:flex-row md:gap-4'
    )}
  >
    {/* Icon */}
    <img src={icon} alt='' className='mt-1 size-6 shrink-0' />

    <div className='flex flex-col'>
      {/* Title */}
      <h4 className='font-sans text-20 font-medium leading-27 text-settings-title'>{title}</h4>

      {/* Description */}
      <div
        className={clsx(
          'mt-1 font-sans text-16 font-normal leading-24 text-settings-text',
          isEditing && 'opacity-90'
        )}
      >
        {description}
      </div>
    </div>
  </div>
);
